import React from "react";
import PropTypes from "prop-types";

import "./Button.css"

export default class Button extends React.Component {

  static propTypes = {
    className: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    style: PropTypes.object
  }

  onClick = event => {
    if (this.props.onClick) {
      this.props.onClick(event);
    }
  }

  render() {
    const { className, children, style } = this.props;
    return (
      <div style={style} className={`button ${className}`} onClick={this.onClick}>{children}</div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/components/Button.js